/*global inputDirectionChange */

var subscribe = {
    init: function() {
        $('#newsletterBtn').on('click', function(event) {
            event.preventDefault();
            subscribe.validate();
        });
        inputDirectionChange.onChangeAction('#newsletterEmail');
    },
    validateEmail: function(email) {
        var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(email);
    },
    validate: function() {

        var email = $('#newsletterEmail').val(),
            successMsg = $('.newsletter-form .success-msg'),
            errorMsg = $('.newsletter-form .error-msg'),
            submitBtn = $('#newsletterBtn');

        if (submitBtn.hasClass('loading disabled')) {
            return false;
        }

        if (subscribe.validateEmail(email)) {
            submitBtn.prop('disabled', true).addClass('loading disabled');
            $.postJSON(_d.url.contacts.subscribe, $('#newsletterForm').serialize(), function(response) {
                if (!response.error) {
                    errorMsg.hide();
                    successMsg.show();
                    $('#newsletterForm').hide();
                    $('.newsletter-policy').hide();
                } else {
                    successMsg.hide();
                    errorMsg.empty().html(response.message).show();
                    subscribe.enableBtn();
                }
            });
        } else {
            successMsg.hide();
            errorMsg.show();
            subscribe.enableBtn();
        }
        return false;
    },
    enableBtn: function() {
        setTimeout(function() {
            $('#newsletterBtn').prop('disabled', false).removeClass('disabled loading');
        }, 10);
    }
};
